export { default } from './TAGLink';
